import find from 'lodash/fp/find';
import flow from 'lodash/fp/flow';
import replace from 'lodash/fp/replace';
import startCase from 'lodash/fp/startCase';

// We hardcode body metadata images as well
export const getBodyMetadata = () => [
  {
    body: 'Convertible',
    image:
      'https://media.carbook.com/MediaGallery/media/MzA0OTA1Xk1lZGlhIEdhbGxlcnk/xxB50soHrCtmE7k4luDjKSs51bn7Zpip0sJGmzLIQloava5vhkM-PuNumtZPo3Sy/2017BMC740002_320_01.png',
  },
  {
    body: 'Coupe',
    image:
      'https://media.carbook.com/MediaGallery/media/MzA0OTA1Xk1lZGlhIEdhbGxlcnk/4I1Zfq95IsbtfrwiQE8CG1AddwLDslMJTEOGRIOrGVA8o-gO-QAplmJhHdbyG8P_/2017TOC290001_320_01.png',
  },
  {
    body: 'Hatchback',
    image:
      'https://media.carbook.com/MediaGallery/media/MzA0OTA1Xk1lZGlhIEdhbGxlcnk/az3s_AxZZjYqOwHE_dPNXJOaoGdfIcOuX0OnSVnB_YgAR7QDgir4o2M9yTmbwCVL/2016TOC250001_320_01.png',
  },
  {
    body: 'Mini-van',
    image:
      'https://media.carbook.com/MediaGallery/media/MzA0OTA1Xk1lZGlhIEdhbGxlcnk/H4BWJrdi1g0f2VLKtwbIDw1XOJAKdXchtOIxtb3pGhyGEDQd--gnezaJaj_1np8N/2017TOV110003_320_01.jpg',
  },
  {
    body: 'SUV',
    image:
      'https://media.carbook.com/MediaGallery/media/MzA0OTA1Xk1lZGlhIEdhbGxlcnk/e5h4tEp18qkyaCvCIC-xPUl20B5koBAh8izUAlhAdvllJkFFqfcIqbOw1QlP5xkl/2017TOS110003_320_01.jpg',
  },
  {
    body: 'Sedan',
    image:
      'https://media.carbook.com/MediaGallery/media/MzA0OTA1Xk1lZGlhIEdhbGxlcnk/yY0uXZ5ZXSDM88gktKaGFavnTz78Fxlczvgixtv9jyHQ6i_Xhy4TzKkj8eEeFcwG/2017TOC020002_320_01.jpg',
  },
  {
    body: 'Truck',
    image:
      'https://media.carbook.com/MediaGallery/media/MzA0OTA1Xk1lZGlhIEdhbGxlcnk/GzI5cF-8YUpo9yOzc1by0Ss2nLtBKUMIHzIuTuHPhdlwLrF_tKsx2TRHU0L8vaAW/2016FOT110010_320_01.png',
  },
  {
    body: 'Van',
    image:
      'https://media.carbook.com/MediaGallery/media/MzA0OTA1Xk1lZGlhIEdhbGxlcnk/SGXf652KuV_rs6E6CQDV1csjLJlH4wIEaC2DGzNP1YVZYXKaEeKN5Qiqx87Ap3x3/2016FOV330005_320_01.jpg',
  },
  {
    body: 'Wagon',
    image:
      'https://media.carbook.com/MediaGallery/media/MzA0OTA1Xk1lZGlhIEdhbGxlcnk/4I1Zfq95IsZDrqsxYVYz7afdSvcIksmQSeVzSCpZJnAcbU_9dwTpaI-zMvfBqSK1/2017TOC230003_320_01.png',
  },
];

export const getImageForBody = (bodyName: string) =>
  find(({ body }) => body === bodyName)(getBodyMetadata());

const getFeatureUrl = (image: string) =>
  `https://prodigy-cdn.upstart.com/img/features/${image}`;

// We hardcode features (for now) since getting DISTINCT from a multiselect is a hassle
export const getFeatureMetadata = () => [
  { feature: '2nd Row Seating', image: getFeatureUrl('2nd-row-seating.png') },
  { feature: '30+ MPG', image: getFeatureUrl('30-mpg.png') },
  { feature: '3rd Row Seating', image: getFeatureUrl('3rd-row-seating.png') },
  { feature: '4WD/AWD', image: getFeatureUrl('awd.png') },
  { feature: 'Backup Camera', image: getFeatureUrl('backup-camera.png') },
  { feature: 'Bluetooth', image: getFeatureUrl('bluetooth.png') },
  { feature: 'Diesel', image: getFeatureUrl('diesel.png') },
  { feature: 'Hybrid/Electric', image: getFeatureUrl('hybrid-electric.png') },
  { feature: 'Leather Seats', image: getFeatureUrl('leather-seats.png') },
  { feature: 'Navigation', image: getFeatureUrl('navigation.png') },
  { feature: 'Sunroof', image: getFeatureUrl('sunroof.png') },
  { feature: 'V4', image: getFeatureUrl('v4.png') },
  { feature: 'V6', image: getFeatureUrl('v6.png') },
  { feature: 'V8', image: getFeatureUrl('v8.png') },
  { feature: 'Automatic', image: getFeatureUrl('automatic.png') },
  { feature: 'Manual', image: getFeatureUrl('manual.png') },
  { feature: '<8 L/100KM', image: getFeatureUrl('less-8-L-per-km.png') },
];

export const getImageForFeature = (featureName: string) =>
  find(({ feature }) => feature === featureName)(getFeatureMetadata());

// For make images, we use the Prodigy CDN
export const getImageForMake = (make: string) => {
  const makePath = flow(startCase, replace(' ', '-'))(make);
  return {
    make,
    image: `https://prodigy-cdn.upstart.com/img/makes/${makePath}.jpg`,
  };
};

export const getImageForFinanceSource = (financeSource: string) => {
  return `https://prodigy-cdn.upstart.com/img/financeSources/${financeSource}.jpg`;
};
